import { initializeFaro, getWebInstrumentations, BrowserConfig } from '@grafana/faro-web-sdk'
// import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import getEnvVariable from './env-util'

export default async () => {
    const faro = getEnvVariable('faro') as BrowserConfig
    if (!faro?.app || !faro.url || !faro.apiKey) {
        console.warn('Faro configuration is missing or incomplete. Faro will not be initialized.')
        return
    }

    initializeFaro({
        ...faro,
        instrumentations: [...getWebInstrumentations({ captureConsole: true })/*, new TracingInstrumentation()*/]
    })
}
